(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.isMobile = window.matchMedia('(max-width: 1279px)').matches;
      this.header = document.querySelector('.section-header');
      this.promoBanner = document.querySelector('.promo-banner-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.twoRowStickyBehavior = this.getAttribute('data-two-row-sticky-behavior') || 'both-rows';
      this.headerRowTwo = document.querySelector('.header__row-two');
      this.cartIcon = document.querySelector('.header__icon--cart');
      this.headerSearchIcon = document.querySelector('.header__icon--search');
      this.isHeaderTwoRows = this.headerRowTwo !== null;
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setPromoBannerHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        
        // Apply different sticky behavior for two-row layout
        if (this.isHeaderTwoRows && this.twoRowStickyBehavior === 'first-row') {
          document.documentElement.classList.add('first-row-only-sticky');
        }
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.throttle(this.onScroll.bind(this), 16);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setPromoBannerHeight() {
      document.documentElement.style.setProperty('--promo-banner-height', `${this.promoBanner.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    throttle(fn, delay) {
      let lastCall = 0;
      return (...args) => {
        const now = Date.now();
        if (now - lastCall < delay) return;
        lastCall = now;
        return fn(...args);
      };
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        
        if (this.preventHide) return;
        
        // For first-row-only sticky behavior, manage visibility of second row
        if (this.isHeaderTwoRows && this.twoRowStickyBehavior === 'first-row' && this.headerIsAlwaysSticky) {
          this.hideRowTwo();
        }
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        
        // For first-row-only sticky behavior, restore visibility of second row when scrolling up
        if (this.isHeaderTwoRows && this.twoRowStickyBehavior === 'first-row' && this.headerIsAlwaysSticky) {
          this.showRowTwo();
        }
        
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        
        // Reset second row visibility when at the top
        if (this.isHeaderTwoRows && this.headerRowTwo) {
          this.showRowTwo();
        }
        
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    showRowTwo() {
      if (this.headerRowTwo && !this.isMobile) {
        this.headerRowTwo.classList.remove('hidden-on-scroll');
        this.headerRowTwo.style.visibility = 'visible';
        this.headerRowTwo.style.transition = 'opacity 0.3s ease';
        this.headerRowTwo.style.transform = 'translateY(0)';
        this.cartIcon.style.display = 'flex';
        this.headerSearchIcon.style.display = 'flex';
      }
    }

    hideRowTwo() {
      if (this.headerRowTwo && !this.isMobile) {
        this.headerRowTwo.classList.add('hidden-on-scroll');
        this.headerRowTwo.style.transform = 'translateY(-100%)';
        this.headerRowTwo.style.visibility = 'hidden';
        this.headerRowTwo.style.transition = 'opacity 0.3s ease';
        this.cartIcon.style.display = 'none';
        this.headerSearchIcon.style.display = 'none';
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
